import { CctpBridgeWidget } from '@/components/cctp/cctpBridgeWidget'
import { ScrollArea, ScrollBar } from '@/components/common/scrollArea'
import { Content, Page } from '@/components/layout/wrappers'
import { getMetaTags } from '@/utils/meta/getMetaTags'
import type { MetaFunction } from 'react-router'

export const meta: MetaFunction = ({ location }) => {
  return getMetaTags({
    title: 'CCTP Bridge',
    description: `Move USDC between chains with zero fees. Powered by Circle's native CCTP infrastructure.`,
    url: location.pathname,
  })
}

export default function CCTP() {
  return (
    <Page className="max-md:bg-page">
      <ScrollArea className="h-full">
        <Content>
          <div className="sm:my-5 md:my-9">
            <CctpBridgeWidget />
          </div>
        </Content>
        <ScrollBar orientation="vertical" />
      </ScrollArea>
    </Page>
  )
}
